import { lazy } from "react";

const Home = lazy(() => import("../../views/home"));
const Admin = lazy(() => import("../../views/admin"));
const Feedback = lazy(() => import("../../views/feedback"));
const FileUpload = lazy(() => import("../../views/upload"));
const Visualization = lazy(() => import("../../views/visualization"));
const Manual = lazy(() => import("../../views/manual"));

const routes = [
  { component: Home, path: "/" },
  { component: FileUpload, path: "/upload" },
  { component: Visualization, path: "/visualization" },
  { component: Feedback, path: "/feedback" },
  { component: Admin, path: "/admin/*" },
  { component: Manual, path: "/manual" },
];

export default routes;
